<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name" :style="styleLabel">{{ label }}</label>
    <select 
      @change="updateValue($event.target.value)" 
      :name="name" 
      :required="required" 
      class="form-control" 
      :style="styleSelect">
        <option v-if="placeholder" 
          value="" disabled 
          :style="styleOption"
        > 
          {{ placeholder }} 
        </option>
        <option v-for="option in options" :key="option.val" 
          :value="option.val" 
          :selected="value == option.val" 
          :style="styleOption"
        >
          {{ option.label }}
        </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputSelect',
    props: ['name', 'value', 'options', 'required', 'label', 'placeholder', 'error', 'stylesProps'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    },
    computed: {
      styleSelect () {
        if (this.stylesProps) {
          return { 'height': this.stylesProps.select.height, 'font-size': this.stylesProps.select.fontSize }
        }
      },
      styleOption () {
        if (this.stylesProps) return { 'font-size': this.stylesProps.option.fontSize }
      },
      styleLabel () {
        if (this.stylesProps) return { 'font-size': this.stylesProps.label.fontSize }
      }
    }
  }
</script>

<style>
.pa-24 {
  padding: 24px;
}
</style>


// WEBPACK FOOTER //
// InputSelect.vue?61f0afea